import type { MeResponse } from "./types.js";

/**
 * #2513 — who is offered the portal's "Switch account" link.
 *
 * <p>The AR Dept. house tenant's id. A migration-pinned platform fact, mirrored from
 * `platform/core/Tenancy/PlatformTenant.cs` (`HouseTenantId`) — matched by UUID only, never by
 * slug, because a slug is a label a tenant row can change.</p>
 */
export const HOUSE_TENANT_ID = "00000000-0000-0000-0000-000000000001";

/**
 * True when the signed-in viewer is an AR Dept. person: a platform admin, or a principal whose
 * `allowed_tenant_ids` include the house tenant — and in either case not a `client` role. Until
 * `/me` has answered (`undefined`: loading, or failed) the answer is false, so a client never sees
 * the link flash in.
 *
 * <p>This is a VISIBILITY convenience, not an authorisation control: switching account only
 * re-runs the Microsoft sign-in, and the engine authorises whichever account is chosen exactly as
 * it would a fresh sign-in. Hiding the link from client staff keeps their portal uncluttered; it
 * protects nothing.</p>
 */
export function canSwitchAccount(me: MeResponse | undefined): boolean {
  if (!me) return false;
  if (me.role === "client") return false;
  return me.is_platform_admin === true || me.allowed_tenant_ids.includes(HOUSE_TENANT_ID);
}
